module.exports = __webpack_public_path__ + "img/index_m0.913d75f7.jpg";